export default __webpack_public_path__ + "static/media/Frozen-Cake.b8c3c28a.jpg";